import { render, staticRenderFns } from "./xxtr4.vue?vue&type=template&id=5e855536&scoped=true&"
import script from "./xxtr4.vue?vue&type=script&lang=js&"
export * from "./xxtr4.vue?vue&type=script&lang=js&"
import style0 from "./xxtr4.vue?vue&type=style&index=0&id=5e855536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e855536",
  null
  
)

export default component.exports